// extracted by mini-css-extract-plugin
export default {"popover":"CustomMenu_popover__6vt2k","popoverAbove":"CustomMenu_popoverAbove__pock7"};